class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.openedBy = null;
    const closeBtn = this.querySelector("[id^='ModalClose-']");
    closeBtn.addEventListener("click", () => this.hide());
  }
  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (typeof trapFocus === 'function') trapFocus(this, this.querySelector('[role="dialog"]'));
  }
  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    if (this.openedBy) this.openedBy.blur();
    this.removeAttribute('open');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.openedBy);
  }
}
window.customElements.define('modal-dialog', ModalDialog);
